<template>
  <div class="tw-flex tw-flex-col">
    <div class="tw-font-semibold tw-text-2xl tw-p-5 tw-bg-black tw-text-white tw-text-center tw-rounded-t-lg lg:!tw-rounded-t-none"
         :class="{'lg:!tw-rounded-tl-lg': roundTopLeft, 'lg:!tw-rounded-tr-lg': roundTopRight }">
      {{ planName }}
    </div>

    <div class="tw-p-5 tw-flex tw-flex-col tw-flex-grow"
         :class="{'lg:tw-border-0 lg:tw-border-r lg:tw-border-solid lg:tw-border-gray-200': hasBorderRight}">
      <div class="tw-text-center">{{ title }}</div>
      <div class="tw-mt-5">
        <slot name="select"></slot>
      </div>

      <div v-if="priceList.length">
        <div class="tw-font-medium tw-my-4 tw-flex tw-justify-between tw-items-center">
          <span>{{ priceListTitle }}</span>
          <span v-if="discountedPriceValue" class="tw-font-semibold tw-text-sm">
            ${{ discountedPriceValue }}/asset
          </span>
        </div>
        <ul class="tw-list-disc tw-list-outside tw-text-sm tw-min-h-[180px]">
          <li v-for="item in priceList" :key="item.id" class="tw-mb-3">
            <div class="tw-flex tw-justify-between tw-gap-5">
              <div>{{ item.title }}</div>
              <div class="tw-font-semibold">${{ formattedPrice(item.plan) }}</div>
            </div>
          </li>
        </ul>
      </div>


      <div v-if="included.length">
        <div class="tw-border tw-border-dotted tw-border-gray-200 tw-my-6"></div>

        <div class="tw-font-medium tw-mb-4">Included:</div>

        <ul class="tw-list-disc tw-text-sm">
          <li v-for="item in included" :key="item" class="tw-mb-3">
            {{ item }}
          </li>
        </ul>

      </div>
      <div v-if="extras.length">
        <div class="tw-border tw-border-dotted tw-border-gray-200 tw-my-6"></div>
        <div class="tw-font-medium tw-mb-4">Extras:</div>

        <ul class="tw-list-disc tw-text-sm">
          <li v-for="item in extras" :key="item" class="tw-mb-3">
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="tw-flex-grow"></div>
    </div>

  </div>
</template>

<script>
import GeneralMixins from "../../../mixins/GeneralMixins.js";

export default {
  mixins: [GeneralMixins],

  props: {
    planName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    included: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    extras: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    basePrices: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    discountedPrices: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    hasBorderRight: {
      type: Boolean,
      required: false,
      default: false
    },
    roundTopLeft: {
      type: Boolean,
      required: false,
      default: false
    },
    roundTopRight: {
      type: Boolean,
      required: false,
      default: false
    },
    discountedPriceValue: {
      type: Number,
      required: false,
      default: null
    },
  },

  data() {
    return {}
  },

  computed: {
    priceListTitle() {
      if (this.basePrices.length) {
        return "Your price:"
      } else if (this.discountedPrices.length) {
        return "Your price:"
      } else {
        return ""
      }
    },

    priceList() {
      if (this.basePrices.length) {
        return this.basePrices
      } else if (this.discountedPrices.length) {
        return this.discountedPrices
      } else {
        return []
      }
    }
  },

  methods: {
    formattedPrice(price) {
      if (price) {
        if (price.cost) {
          return this.formatPrice(price.cost / 100)
        } else if (price.amount) {
          return `${price.amount / 100}/${price.interval === 'month' ? 'mo' : 'yr'}`
        } else {
          return ""
        }
      }
    }
  }
}
</script>

<!--<style>-->
<!--@tailwind base;-->
<!--@tailwind utilities;-->
<!--</style>-->